import _ from "lodash";
import { types } from "mobx-state-tree";
import { Appointment } from "./Appointment";
import type { AppointmentSnapshotIn } from "./Appointment";
import type { Instance, SnapshotIn, SnapshotOut } from "mobx-state-tree";

export interface AppointmentStoreInstance
  extends Instance<typeof AppointmentStore> {}
export interface AppointmentStoreSnapshotIn
  extends SnapshotIn<typeof AppointmentStore> {}
export interface AppointmentStoreSnapshotOut
  extends SnapshotOut<typeof AppointmentStore> {}

export const AppointmentStore = types
  .model("PetStore", {
    map: types.map(Appointment),
  })
  .actions((self) => {
    return {
      processOne(data: AppointmentSnapshotIn) {
        const existing = self.map.get(data.id);
        if (existing) {
          _.mergeWith(existing, data, (_, next) => {
            if (Array.isArray(next)) return next; // Treat arrays like atoms
          });
          return existing;
        }
        return self.map.put(data as AppointmentSnapshotIn);
      },
    };
  })
  .actions((self) => {
    return {
      processMany(dataList: AppointmentSnapshotIn[]) {
        return dataList.map((data) => {
          return self.processOne(data);
        });
      },
    };
  });
